import { getCurrentCountryCode } from "@/utils/countryConfigUtils";

const normalizeSeed = (value?: string | number): string => {
  const safeValue =
    value === null || value === undefined || value === "" ? "guest" : String(value);
  return `u${safeValue}`;
};

const DEFAULT_SKIN_COLORS = "763900,9e5622";
const MX_SKIN_COLORS = "9e5622,ecad80,f2d3b1";

export const getAvatarUrl = (value?: string | number, size = 80): string => {
  const seed = normalizeSeed(value);
  const countryCode = getCurrentCountryCode()?.toLowerCase();
  const skinColor = countryCode === "mx" ? MX_SKIN_COLORS : DEFAULT_SKIN_COLORS;
  return `https://api.dicebear.com/7.x/adventurer/svg?seed=${encodeURIComponent(
    seed
  )}&size=${size}&scale=150&skinColor=${skinColor}`;
};
